const mapLocations = () => {

    if ($('body').hasClass("page--szkolenie")) {

        var map;
        var lat;
        var lng;
        var myCenter;
        var marker;
        var button;
        var address;
        var geocoder = new google.maps.Geocoder();

        $('body').on('click', function(e) {
            $('.localization').each(function(index) {
                //the 'is' for buttons that trigger popups
                //the 'has' for icons within a button that triggers a popup
                if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                    $(this).popover('hide');
                }

            });
        });

        google.maps.event.addDomListener(window, "resize", resizingMap());

        //show popover
        $('.localization').popover({
            html: true,
            container: 'body',
            content: function() {
                button = this;
                address = button.getAttribute('data-address');
                
                geocoder.geocode( { 'address': address}, function(results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        lat = results[0].geometry.location.lat();
                        lng = results[0].geometry.location.lng();
                    
                        myCenter = new google.maps.LatLng(lat, lng);
                        
                        var mapProp = {
                            center: myCenter,
                            zoom: 14,
                            draggable: true,
                            scrollwheel: false
                        };
                        
                        //var mapElem = button.closest('body').querySelector('.popover .map');
                        var mapElem = $('.popover .map')[0];
                        
                        map = new google.maps.Map(mapElem, mapProp);

                        marker = new google.maps.Marker({
                            position: myCenter,
                            icon: '/assets/img/svg/pin_map.svg',
                            map: map
                        });
                                     
                        // create info window
                        var infowindow = new google.maps.InfoWindow({
                            content     : address
                        });

                        // show info window when marker is clicked
                        google.maps.event.addListener(marker, 'click', function() {
                            infowindow.open( map, marker );
                        });
                    } 
                });
 
                var getHtml = $(button).next().html();
                return getHtml
            }

        });
        
        $('.localization').on('shown.bs.popover', function() {
            setTimeout(function(){
                resizeMap();
            },0)    
            
        });

        function resizeMap() {
            if (typeof map == "undefined") return;
            setTimeout(function() {
                resizingMap();
            }, 400);
        }

        function resizingMap() {
            if (typeof map == "undefined") return;
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(myCenter);
        }
    }
};

module.exports = {
    mapLocations,
};